export default {
  setIsOffline (state, payload) {
    state.isOffline = payload
  }
}